import { useState } from "react";

export const useConfirmation = (action?: any) => {
  const [confirmation, setConfirmation] = useState<boolean>(false);

  const openConfirmationHandler = () => {
    setConfirmation(true);
  };

  const closeConfirmationHandler = () => {
    setConfirmation(false);
  };

  const submitConfirmationHandler = () => {
    if (action) {
      action();
    }
    closeConfirmationHandler();
  };

  return {
    confirmation,
    openConfirmationHandler,
    closeConfirmationHandler,
    submitConfirmationHandler,
  };
};
